<template>
  <div id="contract-repayment-info" class="box">
    <b-container>
      <h2>{{ $t(liquidization ? 'LIQUIDIZATION_INFO' : 'REPAYMENT_INFO') }}</h2>

      <div class="checkbox-wrapper" v-if="false || liquidization">
        <input type="checkbox" :checked="canEditOverdueFee" @change="toggleCanEditOverdueFee()" />
        <label class="label">{{ $t('EDIT_OVERDUE_FEE') }}</label>
      </div>

      <b-row>
        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <date-input
            :value="moment(contract.submittedOn, DATE_FORMAT).format(DISPLAY_DATE_FORMAT)"
            :label="$t('DISBURSEMENT_DATE')"
            borderbottom
            disabled
          />
        </b-col>

        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <date-input
            :value="moment(contract.maturesOn, DATE_FORMAT).format(DISPLAY_DATE_FORMAT)"
            :label="$t('MATURE_DATE')"
            borderbottom
            disabled
          />
        </b-col>

        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <date-input
            v-model="repaymentDate"
            :label="$t('REPAYMENT_DATE')"
            required
            borderbottom
            disabled
            ref="repaymentDateInput"
            :validate="validateRepaymentDate"
          />
        </b-col>

        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <text-input
            :label="$t('APPROVED_AMOUNT')"
            :value="(contract.approvedAmount / MILLION).toFixed(3)"
            :hint="changeDigitToViText((contract.approvedAmount / MILLION).toFixed(3))"
            borderbottom
            disabled
          />
        </b-col>

        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <text-input
            :label="$t('PRINCIPAL_AMOUNT')"
            :value="(contract.principalAmount / MILLION).toFixed(3)"
            :hint="changeDigitToViText((contract.principalAmount / MILLION).toFixed(3))"
            borderbottom
            disabled
          />
        </b-col>

        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <text-input
            :label="$t('INTEREST_AMOUNT')"
            :value="(contract.interestAmount / MILLION).toFixed(3)"
            :hint="changeDigitToViText((contract.interestAmount / MILLION).toFixed(3))"
            borderbottom
            disabled
          />
        </b-col>

        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <text-input
            :label="$t('ROUNDING_FEE')"
            :value="(contract.roundingFee / MILLION).toFixed(3)"
            :hint="changeDigitToViText((contract.roundingFee / MILLION).toFixed(3))"
            borderbottom
            disabled
          />
        </b-col>

        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <text-input
            :label="$t('NUMBER_OF_LATE_DAYS')"
            :value="numberOfLateDays"
            borderbottom
            disabled
          />
        </b-col>

        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <text-input
            :label="$t('OVERDUE_FEE')"
            v-model="overdueFeeSwap"
            :hint="changeDigitToViText(overdueFeeSwap)"
            borderbottom
            :disabled="!canEditOverdueFee"
          />
        </b-col>

        <!-- TODO: show late fee for storage -->

        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <text-input
            :label="$t((contract.renewalDifference <= 0) ? 'OLD_CNTRCT_PENALTY' : 'OLD_CNTRCT_REFUND')"
            :value="(Math.abs(contract.renewalDifference) / MILLION).toFixed(3)"
            :hint="changeDigitToViText((Math.abs(contract.renewalDifference) / MILLION).toFixed(3))"
            borderbottom
            disabled
          />
        </b-col>

        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <text-input
            :label="$t('WAIVED_AMOUNT')"
            :value="(contract.waivedAmount / MILLION).toFixed(3)"
            :hint="changeDigitToViText((contract.waivedAmount / MILLION).toFixed(3))"
            borderbottom
            disabled
          />
        </b-col>

        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <text-input
            :label="$t('FAILED_COMMITMENT_FEE')"
            :value="(failedCommitmentFee / MILLION).toFixed(3)"
            :hint="changeDigitToViText((failedCommitmentFee / MILLION).toFixed(3))"
            borderbottom
            disabled
          />
        </b-col>

        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <text-input
            :label="$t('TOTAL_AMOUNT')"
            :value="(totalAmount / MILLION).toFixed(3)"
            :hint="changeDigitToViText((totalAmount / MILLION).toFixed(3))"
            borderbottom
            disabled
          />
        </b-col>

        <b-col xs="12" md="6" lg="4" class="input-wrapper">
          <text-input
            :label="$t(liquidization ? 'RECEIVED_AMOUNT' : 'RECEIVED_AMOUNT_FROM_CLIENT')"
            :value="repaidAmount"
            :hint="changeDigitToViText(repaidAmount)"
            borderbottom
            disabled
            :validate="validateRepaidAmount"
            ref="repaidAmountInput"
          />
        </b-col>
        <b-col xs="12" md="6" lg="4" class="input-wrapper" v-if="!liquidization">
          <text-input
            :label="$t('STORAGE_FEE_LATE')"
            v-model="storageFeeLate"
            :hint="changeDigitToViText(storageFeeLate)"
            borderbottom
          />
        </b-col>
        <b-col xs="12" md="6" lg="4" class="input-wrapper" v-if="liquidization">
          <text-input
            :label="$t('LIQUIDIZATION_FEE')"
            :value="(liquidizationFee / MILLION).toFixed(3)"
            :hint="changeDigitToViText((liquidizationFee / MILLION).toFixed(3))"
            borderbottom
            disabled
          />
        </b-col>
        <b-col xs="12" md="6" lg="4" class="input-wrapper" v-if="liquidization">
          <text-input
            :label="$t('LIQUIDIZATION_RATE')"
            v-model="liquidizationRate"
            borderbottom
            type="number"
            :format="checkPercentage"
            required
          />
        </b-col>
      </b-row>
    </b-container>

    <b-container>
      <h2>{{ $t('TRANSACTIONS') }}</h2>

      <transaction-list
        v-if="!!contract.id"
        :contract-id="contract.id"
        :disbursed-on="contract.submittedOn"
        v-model="transactions"
        ref="transactionsRef"
      />
    </b-container>
  </div>
</template>

<script>
import { ref, computed, watch, watchEffect } from '@vue/composition-api';
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

import TextInput from '@/components/TextInput';
import DateInput from '@/components/DateInput';
import TransactionList from '@/components/TransactionList';

import { DISPLAY_DATE_FORMAT, DATE_FORMAT, MILLION, CASH_LOG_TYPES, TRANSACTION_STATUSES, TRANSACTION_ACTIONS } from '@/consts';
import { changeDigitToViText } from '@/helpers';

const { useState: useAppState } = createNamespacedHelpers('app');
const { useGetters: useUserGetters } = createNamespacedHelpers('user');

export default {
  name: 'ClientForm',
  components: {
    TextInput,
    DateInput,
    TransactionList
  },
  props: {
    contract: {
      type: Object,
      default: () => {}
    },
    liquidization: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { products } = useAppState(['products']);
    const { superuser } = useUserGetters(['superuser']);

    const repaymentDate = ref(moment().format(DISPLAY_DATE_FORMAT));
    const repaymentDateInput = ref(null);
    const repaidAmount = ref(0);
    const repaidAmountInput = ref(null);
    const transactions = ref([]);
    const transactionsRef = ref(null);
    const storageFeeLate = ref(0);
    const liquidizationRate = ref(10);

    const sum = computed(() => transactions.value
      .filter((t) => ((t.action !== TRANSACTION_ACTIONS.WAIVE) && (t.status !== TRANSACTION_STATUSES.RETRACTED) && !t.parentId))
      .reduce((prev, t) => (parseFloat(t.amount || 0) + parseFloat(prev || 0)).toFixed(3), 0));
    const lastTransactionDate = computed(() => transactions.value.filter((t) => (t.status !== TRANSACTION_STATUSES.RETRACTED))[0]?.registeredOn);

    const contract = computed(() => props.contract);

    const product = computed(() => products.value.find((p) => p.id === contract.value.productId));

    const numberOfLateDays = computed(() => {
      if (!repaymentDate.value) return 0;

      const maturityDate = moment(contract.value.maturesOn);
      const date = moment(repaymentDate.value, DISPLAY_DATE_FORMAT);
      const diff = date.diff(maturityDate, 'days');

      return (diff < 0) ? 0 : diff;
    });

    const canEditOverdueFee = ref(false || props.liquidization);
    const overdueFeePerDay = computed(() => (contract.value.interestAmount / product.value?.loanTerm / MILLION));
    const overdueFeeSwap = ref(0);
    const overdueFee = computed(() => {
      const amount = Math.round(parseFloat(overdueFeeSwap.value) * 1000);
      return amount * 1000;
    });

    const lastedCommitmentDays = computed(() => {
      const originallySubmittedOn = moment(contract.value.originallySubmittedOn, DATE_FORMAT);
      const date = moment(repaymentDate.value, DISPLAY_DATE_FORMAT);
      let diff = date.diff(originallySubmittedOn, 'days');

      const maturityDate = moment(contract.value.maturesOn);
      const lateDays = date.diff(maturityDate, 'days');

      if (lateDays <= 0) {
        diff = maturityDate.diff(originallySubmittedOn, 'days');
      }

      return diff;
    });

    const failedCommitmentDays = computed(() => {
      if (!product.value) return 0;

      const diff = product.value.commitmentDays - lastedCommitmentDays.value;

      return (diff > 0) ? diff : 0;
    });

    const failedCommitmentFee = computed(() => {
      if (failedCommitmentDays.value <= 0) {
        return 0;
      }

      const amount = Math.round(((((contract.value.principalAmount * product.value.commitmentPenaltyRate) / product.value?.loanTerm) / 100) * lastedCommitmentDays.value) / 1000) * 1000;

      return amount;
    });

    const toggleCanEditOverdueFee = () => {
      canEditOverdueFee.value = !canEditOverdueFee.value;
    };

    const liquidizationFee = computed(() => (props.liquidization
      ? (
        (((
          contract.value.principalAmount
          + contract.value.interestAmount
          + contract.value.roundingFee
        ) * parseFloat(liquidizationRate.value)) / 100)
      )
      : 0
    ));

    const totalAmount = computed(() => (
      contract.value.principalAmount
      + contract.value.interestAmount
      + contract.value.roundingFee
      + overdueFee.value
      - contract.value.renewalDifference
      - contract.value.waivedAmount
      + liquidizationFee.value
      + failedCommitmentFee.value
    ));

    const validateRepaymentDate = (val) => {
      const date = moment(val, DISPLAY_DATE_FORMAT, true).startOf('day');

      if (date.isValid()) {
        const disbursementDate = moment(contract.value.submittedOn).startOf('day');
        const today = moment().startOf('day');
        const lim = today.clone().subtract(10, 'day');

        if (!superuser.value) {
          if (
            (disbursementDate > date)
            || (today < date)
            || (date < lim)
          ) {
            return 'INVALID_REPAYMENT_DATE';
          }
        }

        return '';
      }

      return 'INVALID_DATE_FORMAT';
    };

    const validate = () => {
      const inputs = [
        repaymentDateInput.value,
        repaidAmountInput.value
      ];

      let valid = true;

      inputs.forEach((input) => {
        const v = input.validateInput();
        valid = valid && v;
      });

      const transactionsValid = transactionsRef.value.validate();
      valid = valid && transactionsValid;

      return valid;
    };

    const validateRepaidAmount = (val) => {
      const amount = Math.round(val * 1000) * 1000;
      if (amount < totalAmount.value) {
        return 'INVALID_AMOUNT';
      }

      return '';
    };

    const emitRepaymentInfo = () => {
      emit('input', {
        overdueFee: overdueFee.value,
        overridedOverdueFee: canEditOverdueFee.value ? overdueFee.value : null,
        liquidizationFee: liquidizationFee.value,
        failedCommitmentFee: failedCommitmentFee.value,
        transactions: transactions.value.map((t) => ({
          ...t,
          registeredOn: moment(t.registeredOn, DISPLAY_DATE_FORMAT).format(DATE_FORMAT),
          amount: parseInt(Math.round(parseFloat(parseFloat(t.amount).toFixed(3)) * 1000) * 1000, 10)
        })),
        storageFeeLate: parseInt(Math.round(parseFloat(parseFloat(storageFeeLate.value).toFixed(3)) * 1000) * 1000, 10)
      });
    };

    const emitTransactions = () => {
      emit('transactions', transactions);
    };

    const checkPercentage = (val) => {
      let val_ = Math.abs(parseFloat(val));
      if (val_ < 1) val_ = 1;
      if (val_ > 100) val_ = 100;

      return val_;
    };

    watchEffect(() => {
      if (canEditOverdueFee.value) return;

      const overduePerDay = Math.round(overdueFeePerDay.value * MILLION);
      let amount = overduePerDay * numberOfLateDays.value;
      amount = Math.round(amount / 1000);

      overdueFeeSwap.value = (amount / 1000).toFixed(3);
    });

    watch(sum, (val) => {
      repaidAmount.value = val;
      emitRepaymentInfo();
    });

    watch(lastTransactionDate, (val) => {
      repaymentDate.value = val;
      emitRepaymentInfo();
    });

    watch(transactions, () => {
      emitRepaymentInfo();
      emitTransactions();
    });

    watch(storageFeeLate, (val) => {
      storageFeeLate.value = val;
      emitRepaymentInfo();
    });

    watch(contract, (val) => {
      if (!val) return;

      if (props.liquidization) {
        overdueFeeSwap.value = contract.value.chargedOverdueFee / MILLION;
      }
    }, {
      immediate: true
    });

    return {
      moment,
      DATE_FORMAT,
      DISPLAY_DATE_FORMAT,
      MILLION,
      repaymentDate,
      repaymentDateInput,
      validateRepaymentDate,
      changeDigitToViText,
      numberOfLateDays,
      overdueFee,
      totalAmount,
      repaidAmount,
      CASH_LOG_TYPES,
      repaidAmountInput,
      validate,
      validateRepaidAmount,
      transactions,
      transactionsRef,
      storageFeeLate,
      toggleCanEditOverdueFee,
      canEditOverdueFee,
      overdueFeeSwap,
      liquidizationRate,
      checkPercentage,
      liquidizationFee,
      failedCommitmentFee
    };
  }
};
</script>

<style lang="scss">
@import "~@/assets/scss/colors";

#contract-repayment-info {
  .date-of-birth-input {
    svg {
      cursor: pointer;
      transition: all .2s ease-in-out;

      &:hover {
        color: $paradisePink;
      }
    }

    .toggle-box-wrapper {
      top: 44px;
    }
  }

  .checkbox-wrapper {
    margin-bottom: 15px;
    display: inline-block;
    margin-right: 30px;

    .label {
      margin-left: 5px;
      vertical-align: top;
    }

    input {
      vertical-align: top;
      margin-top: 6px;
      cursor: pointer;
    }
  }
}
</style>
